import React, {Component} from 'react';
import {gpn} from "../../GPN"

class Document extends Component {

    state = {};

    render() {
        return (
            <div className="document">

            </div>
        );
    }
}

export default gpn(Document);